import React from 'react';
import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const ApiIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <text fill="currentColor" x="0" y="16" fontFamily="arial" fontSize="14">API</text>
  </SvgIcon>;
};
